<template>
  <div id="login">
    <div class="login-content">
      <div class="login-screen">
        <div class="left">
          <img src="../assets/images/brands/holacon-logo.svg" height="48" alt="" />
          <div class="left-login-text">
            <div class="left-login-text-title text-center">
              {{ $t("auth.forgotPassword.title") }}
            </div>
            <div class="left-login-text-content text-center">
              <span v-if="!sent">{{ $t("auth.forgotPassword.forgotDesc") }}</span>
              <span v-else>{{ $t("auth.forgotPassword.forgotDescEnterCode") }}</span>
            </div>
          </div>
          <div class="left-input-area">
            <div class="left-login-input-box" v-if="sent != true">
              <label>{{ $t("auth.login.email") }}</label>
              <el-input v-model="form.email" prefix-icon="fas fa-envelope" :placeholder="$t('enums.inputTypes.mail')" :class="$inputError('email', validationErrors)"></el-input>
            </div>

            <template v-if="sent == true">
              <div class="left-login-input-box">
                <label>{{ $t("auth.forgotPassword.resetKey") }}</label>
                <el-input v-model="form.resetKey" prefix-icon="fas fa-envelope" :placeholder="$t('auth.forgotPassword.resetKey')" :class="$inputError('resetKey', validationErrors)"></el-input>
              </div>
              <div class="left-login-input-box">
                <label>{{ $t("auth.forgotPassword.password") }}</label>
                <el-input v-model="form.password" prefix-icon="fas fa-envelope" :placeholder="$t('auth.forgotPassword.password')" :class="$inputError('password', validationErrors)"></el-input>
              </div>
              <div class="left-login-input-box">
                <label>{{ $t("auth.forgotPassword.repassword") }}</label>
                <el-input v-model="form.passwordRetry" prefix-icon="fas fa-envelope" :placeholder="$t('auth.forgotPassword.repassword')" :class="$inputError('passwordRetry', validationErrors)"></el-input>
              </div>
            </template>
            <!-- <div class="left-login-input-box">
              <label>{{ $t("auth.login.password") }}</label>
              <el-input prefix-icon="fas fa-lock" type="password" show-password v-model="form.password" :placeholder="$t('registerInput.password')" :class="$inputError('password', validationErrors)"></el-input>
            </div> -->
          </div>
          <div class="left-button-area">
            <a v-if="sent == true" @click.prevent="send" :loading="loading == 'sendMail'" class="left-login-button-2">
              <span>{{ $t("auth.forgotPassword.resend") }}</span>
            </a>
            <el-button v-if="sent != true" type="success" @click="send" :disabled="loading == 'send-mail'" class="left-login-button ml-auto">
              <i class="fas fa-sign-in-alt" v-if="loading == false"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
              <div>{{ $t("auth.forgotPassword.reset") }}</div>
            </el-button>
            <el-button v-if="sent == true" type="success" @click="resetPassword" :disabled="loading == 'send-mail'" class="left-login-button ml-auto">
              <i class="fas fa-sign-in-alt" v-if="loading == false"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
              <div>{{ $t("auth.forgotPassword.reset") }}</div>
            </el-button>
          </div>
          <div class="left-register-reminder text-center" @click="goBackLogin">
            {{ $t("auth.register.existAccount") }}
            <span class="cursor-pointer">
              {{ $t("auth.login.login") }}
            </span>
          </div>

          <div class="left-language-selector">
            <div class="left-language-option " @click="changeLocale('tr')" :class="{ active: $i18n.locale == 'tr' }">
              TR
            </div>
            <div class="left-language-option " @click="changeLocale('en')" :class="{ active: $i18n.locale == 'en' }">
              EN
            </div>
          </div>
        </div>

        <div class="right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import axios from "axios";
export default {
  metaInfo: {
    title: "Şifremi Unuttum"
  },
  name: "ForgotPassword",
  data() {
    return {
      form: {
        email: null,
        resetKey: null,
        password: null,
        passwordRetry: null
      },
      loading: false,
      moment,
      timeout: null,
      validationErrors: [],
      sent: this.$route.query.code != undefined ? true : false
    };
  },
  mounted() {
    if (this.$route.query.code != undefined) {
      this.form.resetKey = this.$route.query.code;
    }
  },
  methods: {
    goBackLogin() {
      this.$router.push({ name: "login" });
    },
    send() {
      this.loading = "sendMail";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/forgotpassword", this.form);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.sent = true;
          this.$message.success(res.data.alert.message);
        }
        this.loading = false;
      }, 500);
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      moment.locale(locale);
      localStorage.setItem("lang", locale);
      axios.defaults.headers['language'] = locale;
    },
    resetPassword() {
      this.loading = "resetPassword";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/resetpassword", this.form);
        this.loading = false;
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          await this.$store.commit("setToken", res.data.data.token);
          await this.$store.dispatch("getUser");
          this.$router.push({ name: "myevents" });
        }
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.lang {
  width: 10px;
  height: 10px;
  font-size: 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.el-button + .el-button {
  margin-left: 2px;
}
#login {
  & > .login-content {
    width: 100%;
    min-height: 100vh;
    background-image: url("../assets/images/backgrounds/login-bg.png");
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .login-screen {
      background-color: white;
      border-radius: 1rem;
      max-width: 900px;
      width: 50%;
      display: flex;

      overflow: hidden;
      filter: drop-shadow(0px 2px 10px rgba(41, 47, 59, 0.1));
      min-height: 690px;
      height: auto;
      .left {
        width: 600px;
        display: flex;
        flex-direction: column;
        gap: 32px;
        padding: 4rem;
        min-height: 690px;
        // <div class="left-login-text">
        //     <div class="left-login-text-title"></div>
        //     <div class="left-login-text-content"></div>
        //   </div>
        .left-login-text {
          display: flex;
          flex-direction: column;
          gap: 8px;
          .left-login-text-title {
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 36px;
            color: #292f3b;
            text-transform: capitalize;
          }
          .left-login-text-content {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: #8c929c;
          }
        }
        .left-input-area {
          display: flex;
          flex-direction: column;
          gap: 16px;
          .input-box {
            display: flex;
            gap: 8px;
            flex-direction: column;
            label {
              margin-bottom: 0;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #505763;
            }
            .el-input {
              input {
                border: 1px solid #c8cdd3;
                background-color: white !important;
              }
            }
          }
        }
        .left-button-area {
          display: flex;
          align-items: center;
          & > div {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            letter-spacing: 0.2px;
            text-decoration-line: underline;
            cursor: pointer;
            color: #268ea6;
            max-height: 40px;
          }

          justify-content: space-between;
        }
        .left-register-reminder {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          letter-spacing: 0.2px;
          span {
            font-weight: 500;
            color: #268ea6;
          }
        }
        .left-language-selector {
          max-width: 256px;
          width: 256px;
          height: 48px;
          align-self: center;
          background: #ffffff;
          padding: 8px;
          box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
          border-radius: 48px;
          display: flex;
          .left-language-option {
            width: 119px;
            height: 32px;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            cursor: pointer;
            justify-content: center;
            text-align: center;
            letter-spacing: 0.2px;
            border-radius: 48px;

            transition: all 0.5s;
            &.active {
              background: #268ea6;
              color: white;
              border-radius: 48px;
            }
          }
        }
      }
      .right {
        width: 300px;
        background-image: url("../assets/images/backgrounds/holacon-side-column-image.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: auto;
      }
    }
  }
}
</style>
<style lang="less">
.left-login-input-box {
  display: flex;
  gap: 8px;
  flex-direction: column;
  label {
    margin-bottom: 0;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #505763;
  }
  .el-input {
    input {
      border: 1px solid #c8cdd3;
      background-color: white !important;
    }
    .el-input__icon.fas {
      font-size: 13px;
      color: #268ea6;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.left-login-button-2 {
  max-width: 120px;
  background-color: transparent;
  border: none;
  & > span {
    display: flex;
    justify-content: center;
    gap: 11px;
    cursor: pointer;
    text-decoration: underline;
    font-style: normal;
    font-weight: 500;
    width: 100% !important;
    font-size: 14px;
    align-items: center;
    color: #3b86ff;
  }
  color: #ffffff;
}
.left-login-button {
  max-width: 120px;
  border: none;
  background: #268ea6 !important;
  & > span {
    display: flex;
    justify-content: center;
    gap: 11px;
    font-style: normal;
    font-weight: 600;
    width: 100% !important;
    font-size: 16px;
    align-items: center;
    & > i {
      font-size: 16px !important;
    }
  }
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue